<template>
  <custom-dialog
    :title="title"
    width="1280px"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <bill-container :title="$t('fms_deposit_registration_refund_dialog.sqtyjxx')">
        <el-row
          style="padding-top: 16px"
          class="item-title-info"
        >
          <el-col :span="8">
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.shen_qing_ren') }}:</span>
            <span class="value">{{ detail.paymentConfirmUser }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.shen_qing_shi_jian') }}:</span>
            <span class="value">{{ momentAmPm($momentLocal(detail.paymentConfirmTime)) }}</span>
          </el-col>
          <!-- 和阿康确认，数据库没有该字段，暂时删除 -->
          <!-- <el-col :span="8">
            <span class="label">{{ $t('page__sqrssgs') }}:</span>
            <span class="value">{{ detail }}</span>
          </el-col> -->
          <el-col :span="8">
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.sqtkfs') }}:</span>
            <span class="value">{{ getDicValue('refund_method', detail.refundMethod) }}</span>
          </el-col>
          <el-col
            :span="8"
            v-if="detail.receivableAccount && detail.refundMethod == 1"
          >
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.yin_hang_zhang_hu') }}:</span>
            <span class="value">{{ detail.receivableAccount }} / {{ detail.receivableBank }}</span>
          </el-col>
          <!-- 和张鹏确认，他说取不到，暂时删除 -->
          <!-- <el-col :span="8">
            <span class="label">{{ $t('page__sqtkms') }}:</span>
            <span class="value">{{ detail.refundDesc }}</span>
          </el-col> -->
        </el-row>
      </bill-container>
      <!-- 应退款押金明细 -->
      <bill-container :title="$t('fms_deposit_registration_refund_dialog.ytkyjmx')">
        <accounts-refund-bill
          ref="orderViewList"
          v-model="orderViewList"
          tableCode="deposit_refund_confirm"
        ></accounts-refund-bill>
      </bill-container>
      <!-- 付款信息-租赁不显示-->
      <bill-container
        :title="$t('fms_deposit_registration_refund_dialog.fu_kuan_xin_xi')"
        v-if="detail.refundMethod && detail.refundMethod != 22"
      >
        <accounts-registration-msg-bill
          ref="msgBill"
          v-model="tradeBoList"
          :outerItem="firstOrderItem"
          :orderNum="getPaymentCode(registerMsg)"
          :payableTotal="payableTotal"
          :billInfo="registerMsg"
          @store="onMsgStore"
          :paymentOrReceivable="paymentOrReceivable"
          :balance="registerMsg.balance"
          :isUseBalance="false"
          :auth="msgBillAuth"
          :paymentClass="detail.refundMethod"
          :isReverse="true"
          :sellerTradeType="0"
          :expandFlowMsg="true"
          :isRefundBill="true"
          :addPaymentInfoForm="addPaymentInfoForm"
        ></accounts-registration-msg-bill>
      </bill-container>
      <!-- 退款信息-租赁余额显示 -->
      <bill-container
        :title="$t('fms_deposit_registration_refund_dialog.tui_kuan_xin_xi')"
        v-if="detail.refundMethod && detail.refundMethod == 22"
      >
        <el-row
          style="padding-top: 16px"
          class="item-title-info"
        >
          <el-col
            :span="24"
            v-if="model.type === 'watch'"
          >
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.jiao_yi_ri_qi') }}:</span>
            <span class="value">{{ billPayment.gmtCreate }}</span>
          </el-col>
          <el-col :span="24">
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.shou_kuan_gong_si') }}:</span>
            <span class="value">{{ billPayment.payableOrgName }}</span>
          </el-col>
          <el-col :span="24">
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.ben_ci_zhuan_ru_yu_e') }}:</span>
            <span class="value">￥{{ payableTotal }}</span>
          </el-col>
          <el-col
            :span="24"
            v-if="model.type !== 'watch'"
          >
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.dqzlye') }}:</span>
            <span class="value">￥{{ (partnerBalance.balanceAmount || 0) - (partnerBalance.lockAmount || 0) }}</span>
          </el-col>
          <el-col :span="24">
            <span class="label">{{ $t('fms_deposit_registration_refund_dialog.zrhkyzlye') }}:</span>
            <span class="value">￥{{ model.type === 'watch' ? (partnerBalance.balanceAmount || 0) - (partnerBalance.lockAmount || 0) : payableTotal + (partnerBalance.balanceAmount || 0) - (partnerBalance.lockAmount || 0) }}</span>
          </el-col>
        </el-row>
      </bill-container>
    </div>
    <!-- 退款登记 -->
    <div
      class="dialog-footer"
      slot="footer"
      v-if="dicMap.bill_refund_state && !isWaitConfirm(firstOrderItem)"
    >
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        @click="onStore"
        v-if="model.type !== 'watch' && firstOrderItem.refundState !== 6"
        type="primary"
      >{{ $t('fms_deposit_registration_refund_dialog.zan_cun') }}</el-button>
      <el-button
        @click="onConfirm"
        v-if="model.type !== 'watch'"
        type="primary"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 确认退款 -->
    <div
      class="dialog-footer"
      slot="footer"
      v-if="dicMap.bill_refund_state && isWaitConfirm(firstOrderItem)"
    >
      <el-button @click="onCancel">{{ $t('Common.com_close') }}</el-button>
      <!-- 拒绝退款 -->
      <el-button @click="onReject">{{ $t('fms_deposit_registration_refund_dialog.ju_jue_tui_kuan') }}</el-button>
      <el-button
        @click="onStore"
        v-if="model.type !== 'watch' && firstOrderItem.refundState !== 6"
        type="primary"
      >{{ $t('fms_deposit_registration_refund_dialog.zan_cun') }}</el-button>
      <el-button
        @click="onConfirm"
        v-if="model.type !== 'watch'"
        type="primary"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import accountsRegistrationMsgBill from '@/pages/fms/components/accounts_registration_msg_bill';
import commonDialogMixin from './dialogMixin';
import billContainer from './bill_container';
import accountsRefundBill from './accounts_refund_bill';
import mixins from './mixins';
// import accountsReceivableDeposit from './accounts_receivable_deposit';
// import collectionInfoBill from './collection_info_bill';

export default {
  name: '',
  mixins: [dialogMixins, commonDialogMixin, mixins],
  props: {
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
  },
  components: {
    accountsRefundBill,
    billContainer,
    accountsRegistrationMsgBill,
  },
  data() {
    return {
      billPaymentCode: '',
      billPayment: {},
      detail: {},
      // 应收款账单列表
      orderViewList: [],
      // 结余明细
      partnerBalance: {},
      partnerBalanceBoList: [],
      // 收款信息
      tradeBoList: [],
      // 银行流水
      tradeSellerBos: [],
      registerMsg: {
        balance: 0,
        deposit: 0,
        billPaymentCode: '',
      },
      firstOrderItem: {},
      addPaymentInfoForm: {}
    };
  },
  mounted() {
    this.orderViewList = this.model.data.billData; // 表格选中行
    this.firstOrderItem = this.orderViewList[0];
    this.getDicMap('bill_refund_state', () => {
      this.getPageInfo(); // 获取收款信息
    });


  },
  computed: {
    payableTotal() {
      const list = this.orderViewList;
      let ret = 0;
      list.forEach((item) => {
        // const { paymentAmount = 0, breakAmount = 0, overdueAmount = 0, depositFee = 0 } = item;
        // // 本期应收金额
        // const termShouldReceive = paymentAmount + breakAmount + overdueAmount + depositFee;
        // ret += termShouldReceive;
        ret += item.depositFee;
      });
      return ret;
    },
    title() {
      if (this.model.title) {
        return this.model.title;
      }
      if (this.model.type === 'watch') {
        return this.$t('fms_deposit_registration_refund_dialog.cktkjl');
      }
      return this.$t('fms_deposit_registration_refund_dialog.que_ren_tui_kuan');
    },
    msgBillAuth() {
      if (this.model.type === 'watch') {
        return [];
      }
      const info = this.firstOrderItem;
      if (info) {
        // 退款中: 新增，编辑，删除
        if (info.refundState === 1) {
          return ['addPayMsg', 'edit', 'del'];
        }

        // 待确认退款: 新增，编辑，删除
        if (info.refundState === 6) {
          return ['relativeFlow'];
        }
      }

      return [];
    }
  },
  methods: {
    onReject() {
      const tips = this.$t('fms_deposit_registration_refund_dialog.nqdyjjtkm');
      this.$showConfirm(tips).then(() => {
        const billPaymentCode = this.getPaymentCode(this.registerMsg);
        this.$postJSON(`${apis.paymentRevoke}/${billPaymentCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.$emit('success');
          this.closeDialog();
        });
      });
    },
    // 判断是否为待确认退款状态
    isWaitConfirm(row) {
      const { refundState } = row;
      return `${refundState}` === `${this.dicMap.bill_refund_state.wait_confirmed}`;
    },
    onMsgStore() {
      // 新增交易信息暂存是为了保存paymentCode,不然每次调用账单详情接口，paymentCode都在变
      // 故，只要新增第一条数据时，就执行暂存
      if (this.tradeBoList.length === 1) {
        this.onStore(false);
      }

    },
    // 更新银行流水
    // updateBankFlow() {
    //   const billPaymentCode = this.getPaymentCode(this.registerMsg);
    //   this.$getJSON(`${apis.paymentBankFlowList}/${billPaymentCode}`).then((res) => {
    //     this.tradeSellerBos = res.data;
    //   });
    // },
    // 获取信息
    getPageInfo() {
      const firstItem = this.orderViewList[0];
      // this.$getJSON(apis.DepositPaymentInfo, { billId: firstItem.billId, receivableOrgId: firstItem.receivableOrgId, payableOrgId: firstItem.payableOrgId }).then((res) => {
      // 被改成如下接口，返回？待确定
      const refundBillId = firstItem.refundBillId || firstItem.billId;
      this.$getJSON(`${apis.paymentPaymentInfo}/${refundBillId}`).then((res) => {
        const data = res.data;
        this.registerMsg = data;
        this.registerMsg.balance = this.registerMsg.balance || 0;
        this.registerMsg.deposit = this.registerMsg.deposit || 0;
        this.billPaymentCode = this.getPaymentCode(res.data);
        this.billPayment = res.data.billPayment;
        // 应付账单信息
        // this.detail = res.data.refundBo || {}; // 已删除
        this.detail = res.data.billPayment || {};

        // 交易列表-添加交易信息时，给form添加的默认信息
        this.addPaymentInfoForm = {
          buyerAccount: this.detail.receivableAccount,
        };

        // 应退押金明细
        if (data.orderViewList && data.orderViewList.length) {
          this.orderViewList = data.orderViewList;
        }
        // 合作伙伴余额
        if (data.partnerBalanceBoList && data.partnerBalanceBoList.length) {
          this.partnerBalanceBoList = data.partnerBalanceBoList;
        }
        // 付款信息
        if (data.tradeBoList && data.tradeBoList.length) {
          this.tradeBoList = [...data.tradeBoList];
          data.tradeBoList.forEach((item, index) => {
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              this.$set(data.tradeBoList[index], 'attachs', this.formatAttachs(imgRes.data));
            });
          });
        }
        // 银行流水
        if (data.tradeSellerBos && data.tradeSellerBos.length) {
          this.tradeSellerBos = data.tradeSellerBos;
        }
        // 余额信息
        this.partnerBalance = data.partnerBalance || {};
      });
    },
    // 删除应收账单信息
    onDelOrderView(index) {
      this.$refs.orderViewList.delRow(index);
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    // 参数处理
    getReqData() {
      const data = this.registerMsg;
      const billPayment = data.billPayment || {};
      const billIdList = this.orderViewList.map(t => t.billId);
      const billPaymentType = 2;
      const billPaymentCode = this.getPaymentCode(this.registerMsg);

      const ret = {
        billIdList,
        billPaymentType,
        billPaymentCode,
        paymentCode: billPaymentCode,
        receivableAccount: billPayment.receivableAccount,
        receivableBank: billPayment.receivableBank,
        receivableBankName: billPayment.receivableBankName,
        receivableName: billPayment.receivableName,
        refundMethod: billPayment.refundMethod,
        tradeList: this.tradeBoList,
        useBalance: billPayment.isUseBalance,
      };

      return ret;
    },
    // 暂存
    onStore(isClose = true) {
      const reqData = this.getReqData();
      this.$postJSON(apis.paymentProvisionalSave, reqData).then(() => {

        this.$emit('success');
        if (isClose) {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.closeDialog();
        } else {
          this.getPageInfo();
        }
      });
    },
    // 确定
    onConfirm() {
      // paymentRegister
      const reqData = this.getReqData();
      const billPaymentCode = this.getPaymentCode(this.registerMsg);
      const info = Array.isArray(this.model.data.billData) ? this.model.data.billData[0] : this.model.data.billData;
      let reqUrl;
      const billRefundState = this.dicMap.bill_refund_state;
      // 退款中
      const refunding = `${billRefundState.ing}`;
      // 待确认退款
      const waitConfirm = `${billRefundState.wait_confirmed}`;
      // 不同退款状态执行不同操作
      // refundState 为1 - 退款中时，意味着账单未支付，需要执行支付
      if (`${info.refundState}` === refunding) {
        reqUrl = apis.paymentRegister;
      }
      // refundState 为 6 - 待确认退款，则执行确认收款
      if (`${info.refundState}` === waitConfirm) {
        reqUrl = `${apis.paymentConfirmPayment}/${billPaymentCode}`;
      }
      const tradeBoList = this.tradeBoList;
      if (tradeBoList.length) {
        const hasEmptyTradeFinishTime = tradeBoList.some(item => !item.tradeFinishTime);
        if (hasEmptyTradeFinishTime) {
          this.$message.error(this.$t('fms_deposit_registration_refund_dialog.fkrqbnwk'));
          return;
        }
      }

      this.$postJSON(reqUrl, reqData).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 撤销付款
    onRevoke() {
      const item = this.orderViewList[0];
      const { billType, billPaymentId } = item;
      this.$postJSON(`${apis.billPaymentRevoke}/${billType}/${billPaymentId}`, {}, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 删除银行流水
    onDelBankFlow(index) {
      this.$showConfirm(this.$t('fms_deposit_registration_refund_dialog.nqdyscxzdyhlsm')).then(() => {
        const curBankFlow = this.tradeSellerBos[index];
        this.$postJSON(`${apis.paymentBankFlowDelete}/${curBankFlow.sellerTradeCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          // 本地
          this.tradeBoList.forEach((item) => {
            if (item.sellerTradeCode === curBankFlow.sellerTradeCode) {
              item.sellerTradeCode = null;
            }
          });
          this.tradeSellerBos.splice(index, 1);
        });
      });
    },
    // 更新银行流水
    updateBankFlow(sellerTrade, isLocal) {
      // 本地
      if (isLocal && sellerTrade) {
        if (sellerTrade.type === 'delete') {
          this.tradeSellerBos = this.tradeSellerBos.filter(t => `${t.sellerTradeCode}` !== `${sellerTrade.sellerTradeCode}`);
        } else {
          this.tradeSellerBos = [...this.tradeSellerBos, sellerTrade];
        }
        return;
      }
      const billPaymentCode = this.getPaymentCode(this.registerMsg);
      this.$getJSON(`${apis.paymentBankFlowList}/${billPaymentCode}`).then((res) => {
        this.tradeSellerBos = res.data;
      });
    },
  },
};
</script>

<style></style>
